import { db, storage, timestamp } from '@/firebaseConfig'

export default {
  state: {
    supplierProducts: []
  },
  mutations: {
    setSupplierProducts(state, supplierProducts) {
      state.supplierProducts = supplierProducts
    },
    addProductToSupplierProducts(state, product) {
      state.supplierProducts.push(product)
    },
    updateProductFromSupplierProducts(state, product) {
      const productIndex = state.supplierProducts.findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.supplierProducts.splice(productIndex, 1, product)
      }
    },
    deleteProductFromSupplierProducts(state, product) {
      const productIndex = state.supplierProducts.findIndex(
        (item) => item.id === product.id
      )
      state.supplierProducts.splice(productIndex, 1)
    }
  },
  actions: {
    // TODO: load 10 first products, then load the rest on next page
    loadSupplierProducts({ commit }, user) {
      return new Promise((resolve, reject) => {
        const productsPath = user.type === 'business' ? `businesses/${user.id}/products` : `independents/${user.id}/products`
        db.collection(productsPath).get()
          .then((snap) => {
            const data = []
            snap.forEach(doc => {
              data.push(doc.data())
            })

            const products = data.filter(product => product.created_at_mills)
            commit('setSupplierProducts', products)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
        // }
      })
    },
    async addProductToSupplierProducts({ commit, getters }, payload) {
      try {
        let user = getters.user
        const isAdmin = user.isAdmin

        if (isAdmin) {
          user = getters.supplier(payload.supplierId)
        }

        const productsPath = user.type === 'business' ? `businesses/${user.id}/products` : `independents/${user.id}/products`

        // initial data to be stored in firestore
        const product = {
          title: payload.title,
          description: payload.description,
          price: payload.price,
          unit: payload.unit,
          province: payload.province,
          district: payload.district,
          imageName: payload.imageName,
          imageLastModified: payload.imageLastModified,
          category: payload.category,
          createdAt: timestamp,
          updatedAt: timestamp,
          // fields for sorting, get they values from a cloud function
          created_at_mills: '',
          supplierId: user.id,
          supplierType: user.type
        }

        // store text to firestore
        const data = await db.collection(productsPath).add(product)
        const productId = data.id

        const filesData = await storage.ref().child(`${productsPath}/${productId}`).put(payload.image)

        // get compressed image fullpath from storage
        const imageFullPath = `${filesData.metadata.fullPath}`
        // get image url
        const imageUrl = await storage.ref().child(imageFullPath).getDownloadURL()

        const re = new RegExp(productId, 'g')
        const resizedUrl = imageUrl.replace(re, `${productId}_200x200`)
        // update firestore to reference fullpath & url
        await db.doc(`${productsPath}/${productId}`).update({ id: productId, imageFullPath, imageUrl, resizedUrl })

        if (payload.newUnit) {
          /** add the new unit to the firestore */
          const unitDetails = {
            name: payload.unit,
            supplierId: user.id,
            supplierFirstName: user.firstName,
            productId
          }

          await db.collection('units').add(unitDetails)
        }

        /**
       * to solve updated error (TypeError: Converting circular structure to JSON) and button not showing up after creating product,
       * delete createdAt and updatedAt properties
       */
        delete product.createdAt
        delete product.updatedAt

        const allProductDetails = { ...product, id: productId, supplierId: user.id, imageFullPath, imageUrl, resizedUrl }

        if (isAdmin) {
          commit('addProductToAllSuppliersProducts', allProductDetails)
        } else {
          commit('addProductToSupplierProducts', allProductDetails)
        }

        commit('addProductToCurrentProducts', { product: allProductDetails, isNewProduct: true })
        commit('addProductToAllProducts', { product: allProductDetails, isNewProduct: true })
        return 'success'
      } catch (err) {
        return err
      }
    },

    async updateProductFromSupplierProducts({ commit, getters }, payload) {
      try {
        let user = getters.user
        const isAdmin = user.isAdmin

        if (isAdmin) {
          // use the supplier's data to update the product
          user = getters.supplier(payload.supplierId)
        }

        const productPath = user.type === 'business' ? `businesses/${user.id}/products/${payload.id}` : `independents/${user.id}/products/${payload.id}`

        /**
         * if payload contains an image
         * - delete the old one from firebase storage
         * - add the new one to firebase storage
         * - add imageUrl and fullPath to the payload
         */
        if (payload.image) {
          // delete the old image
          await storage.ref().child(payload.imageFullPath).delete

          // upload a new one
          const fileData = await storage.ref().child(productPath).put(payload.image)
          const newImageFullPath = fileData.metadata.fullPath

          // creating ref to our image file and get the url
          const url = await storage.ref().child(newImageFullPath).getDownloadURL()

          payload.imageFullPath = newImageFullPath
          payload.imageUrl = url
          const re = new RegExp(payload.id, 'g')
          const resizedUrl = url.replace(re, `${payload.id}_200x200`)
          payload.resizedUrl = resizedUrl
          // update firestore with the payload
          // 1. we can't upload an image to firestore, so we remove it first
          delete payload.image

          const productRef = db.doc(productPath)
          await productRef.update(payload)

          /** add the new unit to the firestore */
          if (payload.newUnit) {
            const unitDetails = {
              name: payload.unit,
              supplierId: user.id,
              supplierFirstName: user.firstName,
              productId: payload.id
            }

            await db.collection('units').add(unitDetails)
          }

          /**
           * commit changes
           */
          if (isAdmin) {
            commit('updateProductFromAllSuppliersProducts', { product: payload, supplierId: payload.supplierId })
          } else {
            commit('updateProductFromSupplierProducts', payload)
          }

          commit('updateProductFromCurrentProducts', payload)
          commit('updateProductFromAllProducts', payload)
          return 'success'
        } else {
          /**
           * update fields only
           * update firestore with the payload
           * */
          //    1. we can't upload an image to firestore, so we remove it first
          delete payload.image

          await db.doc(productPath).update(payload)

          /** add the new unit to the firestore */
          if (payload.newUnit) {
            const unitDetails = {
              name: payload.unit,
              supplierId: user.id,
              supplierFirstName: user.firstName,
              productId: payload.id
            }

            await db.collection('units').add(unitDetails)
          }

          /**
           * commit changes
           */
          if (isAdmin) {
            commit('updateProductFromAllSuppliersProducts', { product: payload, supplierId: payload.supplierId })
          } else {
            commit('updateProductFromSupplierProducts', payload)
          }

          commit('updateProductFromCurrentProducts', payload)
          commit('updateProductFromAllProducts', payload)

          return 'success'
        }
      } catch (err) {
        return err
      }
    },
    async deleteProductFromSupplierProducts({ commit, getters }, payload) {
      try {
        let user = getters.user
        const isAdmin = user.isAdmin
        if (isAdmin) {
          user = getters.supplier(payload.supplierId)
        }

        const productPath = user.type === 'business' ? `businesses/${user.id}/products/${payload.id}` : `independents/${user.id}/products/${payload.id}`
        /**
         * delete product from firestore
         */
        await db.doc(productPath).delete()
        /**
         * delete product image from firebase storage
         */
        await storage.ref().child(productPath).delete()
        /**
         * commit deleted product and update local state
         */
        if (isAdmin) {
          commit('deleteProductFromAllSuppliersProducts', { product: payload, supplierId: payload.supplierId })
        } else {
          commit('deleteProductFromSupplierProducts', payload)
        }

        commit('deleteProductFromCurrentProducts', payload)
        commit('deleteProductFromAllProducts', payload)
        return 'success'
      } catch (err) {
        return err
      }
    }
  },
  getters: {
    supplierProducts(state) {
      return state.supplierProducts
    }
  }
}
